import cart from "@/parts/Front/components/cart/cart";
import { router } from "@/main";
import { deleteCookie } from "@/libraries/VueMethods";
import axios from "axios";

export default {
  setUserCart(state, payLoad) {
        let cart = payLoad.cart
        let priority = payLoad.priority || 0
        if (priority >= state.currentCartPriority) {
            state.currentCartPriority = priority
            state.currentCart = cart;
        }
        
        if (state.homeData) {
            state.mainContent.cart = state.currentCart
        }
    },
  setMenu(state, menuObj) {
    state.menu[menuObj.key] = menuObj.value;
  },
  addUserFavorite(state, product) {
    let user = state.mainContent.user;
    if (!user) {
      return null;
    }
    let userUser = state.mainContent.user.user;
    if (!userUser) {
      return null;
    }
    state.mainContent.user.user.favorites.push(product);
  },

  setMainContent(state, contentObj) {
    state.mainContent[contentObj.key] = contentObj.value;
  },
  setLoginStatus(state, status) {
    state.loginStatus = Boolean(status);
    // حذف کردن یوزر و پاک کردن سبد خرید
    let user = state.mainContent.user;
    console.log(user);
    if (status == false && user) {
      delete axios.defaults.headers.common["Authorization"];
      deleteCookie("Authorization");
      let authRoutes = ["callback", "order", "user-panel"];
      authRoutes.every((routeUrl) => {
        if (router.currentRoute.path.includes(routeUrl)) {
          router.push("/");
          return false;
        }
        return true;
      });

      user.login = false;
      user.user = null;
      user.notifications = null;
    } else if (user && typeof status === "object") {
      state.mainContent.user.login = true;
      state.mainContent.user.user = status.user;
      state.mainContent.user.notifications = status.notifications;
      state.mainContent.user = user;
    }
  },
  deleteUserFavorite(state, id) {
    state.mainContent.user.user.favorites = state.mainContent.user.user.favorites.filter(
      (item) => item.id != id
    );
  },
  newAddress(state, address) {
    state.mainContent.user.user.addresses.push(address);
  },
  editAddress(state, address) {
    state.mainContent.user.user.addresses = state.mainContent.user.user.addresses.map(
      (item, index) => {
        if (item.id == address.id) {
          return address;
        }
        return item;
      }
    );
  },
  deleteAddress(state, id) {
    state.mainContent.user.user.addresses = state.mainContent.user.user.addresses.filter(
      (item) => item.id != id
    );
  },
  loadMoreNotifications(state, newNotifications) {
    state.mainContent.user.notifications.items = [
      ...state.mainContent.user.notifications.items,
      ...newNotifications,
    ];
  },
};
